var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 16C24 16 21 10.5 16 10.5C11 10.5 8 16 8 16C8 16 11 21.5 16 21.5C21 21.5 24 16 24 16ZM9.1727 16C9.22963 15.9132 9.29454 15.8168 9.36727 15.7124C9.70216 15.2319 10.1963 14.5929 10.8321 13.9571C12.121 12.6682 13.8806 11.5 16 11.5C18.1194 11.5 19.879 12.6682 21.1679 13.9571C21.8037 14.5929 22.2978 15.2319 22.6327 15.7124C22.7055 15.8168 22.7704 15.9132 22.8273 16C22.7704 16.0868 22.7055 16.1832 22.6327 16.2876C22.2978 16.7681 21.8037 17.4071 21.1679 18.0429C19.879 19.3318 18.1194 20.5 16 20.5C13.8806 20.5 12.121 19.3318 10.8321 18.0429C10.1963 17.4071 9.70216 16.7681 9.36727 16.2876C9.29454 16.1832 9.22963 16.0868 9.1727 16Z",
    fill: "#4B4B4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.5C14.6193 13.5 13.5 14.6193 13.5 16C13.5 17.3807 14.6193 18.5 16 18.5C17.3807 18.5 18.5 17.3807 18.5 16C18.5 14.6193 17.3807 13.5 16 13.5ZM12.5 16C12.5 14.067 14.067 12.5 16 12.5C17.933 12.5 19.5 14.067 19.5 16C19.5 17.933 17.933 19.5 16 19.5C14.067 19.5 12.5 17.933 12.5 16Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.91a6b9e01fec5f4d786610ef720f18db.svg";
export { ForwardRef as ReactComponent };